import GlobalNotification from '@/components/global-notification/CreateGlobalNotification';
import NotificationTable from '@/components/global-notification/NotificationTable';

export default function Home() {
	return (
		<div className="flex items-center justify-center h-full flex-col gap-10 p-5">
			<GlobalNotification />
			<NotificationTable />
		</div>
	);
}
